import { createAction, props } from '@ngrx/store';

import { SideMenuOption } from '@common/modules/core/services/interfaces';

export const sideMenuOptionSelected = createAction('[SideMenu] Side menu option selected ', props<{ option: SideMenuOption }>());
export const sideMenuToggled = createAction('[SideMenu] Side menu toggled', props<{ open: boolean }>());
export const sideMenuInitOption = createAction('[SideMenu] Side menu init option', props<{ option: SideMenuOption }>());
